import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IpServiceService {
  private _ipAdress = new Subject();
  ipAdress$ = this._ipAdress.asObservable();
  constructor(private http: HttpClient) { }
  getIPAddress() {
    //this.http.get('"https://cors-anywhere.herokuapp.com/http://ip-api.com/json/').subscribe( (res: any) => {
    this.http.get('https://api.ipify.org/?format=json').subscribe( (res: any) => {
      this._ipAdress.next(res);
    });
  }
  /*getIPAddress() {
    this.http.get('https://api.ipify.org/?format=json').subscribe( (res: any) => {
      this._ipAdress.next(res.ip);
    });
  }*/
}
